import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';

export class ControlBar {
  private i18n: I18nService;
  private element: HTMLElement;
  private nextBtn: HTMLButtonElement | null = null;
  private autoPlayToggle: HTMLButtonElement | null = null;
  private countdownEl: HTMLElement | null = null;
  private resetBtn: HTMLButtonElement | null = null;

  onNextNumber: (() => void) | null = null;
  onToggleAutoPlay: (() => void) | null = null;
  onReset: (() => void) | null = null;

  constructor(i18n: I18nService) {
    this.i18n = i18n;
    this.element = document.getElementById('control-bar') || document.createElement('nav');
  }

  render(gamePhase: string, autoPlayEnabled: boolean): void {
    const isIdle = gamePhase === 'IDLE';
    const nextLabel = isIdle
      ? this.i18n.t(I18N_KEYS.CONTROLS_START_GAME)
      : this.i18n.t(I18N_KEYS.CONTROLS_NEXT_NUMBER);

    this.element.innerHTML = `
      <div class="controls__container">
        <button id="prev-btn" class="controls__btn controls__btn--prev" disabled type="button" aria-label="${this.i18n.t(I18N_KEYS.CONTROLS_PREVIOUS)}">
          ◀ ${this.i18n.t(I18N_KEYS.CONTROLS_PREVIOUS)}
        </button>
        <button id="next-btn" class="controls__btn controls__btn--next" type="button"
          aria-label="${nextLabel} (N)">
          ▶ ${nextLabel} <kbd>(N)</kbd>
        </button>
        <div class="controls__autoplay">
          <button id="autoplay-toggle" class="controls__btn controls__btn--autoplay ${autoPlayEnabled ? 'controls__btn--autoplay-on' : ''}" 
            role="switch" aria-checked="${autoPlayEnabled}" type="button"
            aria-label="${this.i18n.t(I18N_KEYS.CONTROLS_AUTO_PLAY)}">
            ${this.i18n.t(I18N_KEYS.CONTROLS_AUTO_PLAY)}
          </button>
          <span id="autoplay-countdown" class="controls__countdown" style="display:none;"></span>
        </div>
      </div>
      <div class="controls__reset-row">
        <button id="reset-btn" class="controls__reset-btn" type="button" aria-label="${this.i18n.t(I18N_KEYS.CONTROLS_RESET)} (R)">
          🔄 ${this.i18n.t(I18N_KEYS.CONTROLS_RESET)}
        </button>
      </div>
    `;

    this.nextBtn = this.element.querySelector('#next-btn');
    this.resetBtn = this.element.querySelector('#reset-btn');
    this.autoPlayToggle = this.element.querySelector('#autoplay-toggle');
    this.countdownEl = this.element.querySelector('#autoplay-countdown');

    this.nextBtn?.addEventListener('click', () => {
      console.log('[ControlBar] Next button clicked, disabled:', this.nextBtn?.disabled, 'onNextNumber exists:', !!this.onNextNumber);
      if (this.onNextNumber) {
        console.log('[ControlBar] Calling onNextNumber callback');
        this.onNextNumber();
      } else {
        console.warn('[ControlBar] onNextNumber callback not set!');
      }
    });

    this.autoPlayToggle?.addEventListener('click', () => {
      if (this.onToggleAutoPlay) this.onToggleAutoPlay();
    });

    this.resetBtn?.addEventListener('click', () => {
      if (this.onReset) this.onReset();
    });
  }

  setNextButtonEnabled(enabled: boolean): void {
    if (this.nextBtn) {
      this.nextBtn.disabled = !enabled;
    }
  }

  updateNextButtonLabel(isIdle: boolean): void {
    if (!this.nextBtn) return;
    const label = isIdle
      ? this.i18n.t(I18N_KEYS.CONTROLS_START_GAME)
      : this.i18n.t(I18N_KEYS.CONTROLS_NEXT_NUMBER);
    this.nextBtn.innerHTML = `▶ ${label} <kbd>(N)</kbd>`;
    this.nextBtn.setAttribute('aria-label', `${label} (N)`);
  }

  updateAutoPlayState(enabled: boolean): void {
    if (this.autoPlayToggle) {
      this.autoPlayToggle.setAttribute('aria-checked', String(enabled));
      if (enabled) {
        this.autoPlayToggle.classList.add('controls__btn--autoplay-on');
      } else {
        this.autoPlayToggle.classList.remove('controls__btn--autoplay-on');
      }
    }
    if (!enabled && this.countdownEl) {
      this.countdownEl.style.display = 'none';
    }
  }

  showCountdown(seconds: number): void {
    if (this.countdownEl) {
      this.countdownEl.style.display = 'inline';
      this.countdownEl.textContent = this.i18n.t(I18N_KEYS.CONTROLS_NEXT_IN, { seconds });
    }
  }

  hideCountdown(): void {
    if (this.countdownEl) {
      this.countdownEl.style.display = 'none';
    }
  }

  updateLabels(isIdle: boolean): void {
    this.updateNextButtonLabel(isIdle);
    if (this.autoPlayToggle) {
      this.autoPlayToggle.textContent = this.i18n.t(I18N_KEYS.CONTROLS_AUTO_PLAY);
    }
    if (this.resetBtn) {
      this.resetBtn.innerHTML = `🔄 ${this.i18n.t(I18N_KEYS.CONTROLS_RESET)}`;
      this.resetBtn.setAttribute('aria-label', `${this.i18n.t(I18N_KEYS.CONTROLS_RESET)} (R)`);
    }
  }
}
